import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'src/redux'
import { filesAdapter } from './Slice'
/**
 * Select form data
 */
export const selectApplicantsState = createSelector(
  (state: RootState) => state,
  (state) => state.files
)

export const {
  selectById: selectfileById,
  selectAll: selectfiles,
  selectEntities: selectfileEntities,
} = filesAdapter.getSelectors<RootState>((state) => state.files)

export const selectFilesByApplicant = createSelector(
  [selectfiles, (state: RootState, applicant: string | undefined) => applicant],
  (files, applicant) => files.filter((file) => file.applicant === applicant)
)
